import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './non_empty_hub.less'
import FadeOutLink from 'components/common/fade_out_link'
import HubCampaign from '../hub_campaign'
import smoothScrollPolyfill from 'smoothscroll-polyfill'
import { groupArray } from 'shared/helpers/array_helpers'
import Separator from 'components/common/separator'
import PayPalPage from 'components/common/paypal_page'
import { HeadingText } from '@paypalcorp/pp-react'
import 'node_modules/@paypalcorp/pp-vx/dist/components/text/text.css'

const i18n = getI18n('components/pages/hub/non_empty_hub')

class NonEmptyHub extends React.Component {
  static propTypes = {
    campaigns: PropTypes.array.isRequired,
  }

  componentDidMount() {
    smoothScrollPolyfill.polyfill()
  }

  handleLearnMore = () => {
    this.footer.scrollIntoView({ behavior: 'smooth' })
  }

  render() {
    const groupedCampaigns = groupArray(this.props.campaigns, 3)

    let alertElement

    return (
      <PayPalPage>
        <div styleName="container">
          {alertElement && (
            <div styleName="row">
              <div styleName="alert-col">{alertElement}</div>
            </div>
          )}
          <div styleName="top-area">
            <HeadingText size="lg" styleName="title">
              {i18n('title')}
            </HeadingText>
            <div styleName="add-button-desktop-container">
              <FadeOutLink
                href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
                className="vx_addBtn-primary ppvx_text--body-strong"
                data-pa-click="create"
                data-nemo="create-pool-button"
              >
                {i18n('add_action')}
              </FadeOutLink>
            </div>
          </div>

          <div styleName="row">
            <div styleName="separator-col">
              <Separator />
            </div>
          </div>

          <div styleName="add-button-mobile-container">
            <FadeOutLink
              href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
              className="vx_addBtn-primary"
              data-pa-click="create"
              data-nemo="mweb-create-pool-button"
            >
              {i18n('add_action')}
            </FadeOutLink>
          </div>

          <div styleName="clear" />

          {groupedCampaigns.map(campaignGroup => (
            <div styleName="campaign-row" key={campaignGroup[0].id}>
              {campaignGroup.map(campaign => (
                <div styleName="campaign-col" key={campaign.id}>
                  <HubCampaign campaign={campaign} />
                </div>
              ))}
            </div>
          ))}

          <div styleName="clear" />
        </div>
      </PayPalPage>
    )
  }
}

export default cssModules(NonEmptyHub, styles)
